/**
 * Validation class for Machine Agreement form
 * */
export default class MachineAgrementFormValidation {
    /**
     * Init
     */
    constructor() {
        // Document Ready for jQuery validation
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.ready);
        } else {
            this.ready();
        }
    }

    /**
     * Callback - Init methods when page been loaded
     */
    ready = () => {
        this.validationForm();
        this.validationReciever();
    };

    /**
     * Changing jQuery validation rules
     * @param {*} template
     */
    changeRegexRules(template) {
        this.removeValidationRule();
        this.addValidationRule(template);
    }

    /**
     * Removing Template rules
     */
    removeValidationRule() {
        $('#agreementNumber').rules('remove', 'regex');
        $('#agreementNumber').rules('remove', 'required');
    }

    /**
     * Adding new jQuery validation rule depending on selected template
     * @param {*} template
     */
    addValidationRule = (template) => {
        this.validationMethods({ agreementNumber: template, type: 'form' });

        $('#agreementNumber').rules('add', {
            required: true,
            regex: true,
            messages: {
                required: machineAgreementTranslation.agreementNumberRequired,
                regex: template.msg,
            },
        });    
    };
  
    /**
     * Jquery Validation for agreement
     * @return void
     */
    validationForm = () => {
        this.validationMethods({ type: 'multifiles' });
        $("form[name='machineagreement']").validate({
            rules: {
                agreementFile: {
                    required: true,
                    validateFileTtype: true,
                }
            },
            messages: {
                agreementFile: {
                    required: machineAgreementTranslation.agreementFileRequired,
                    validateFileTtype: machineAgreementTranslation.agreementFileValidateFileTtype,
                }
            },
            submitHandler: function () {
                this.checkForm();
            },
        });
    };

    /**
     * Jquery  Validation for reciever form
     * @return void
     */
    validationReciever() {
        this.validationMethods({
            agreementNumber: {
                regx: /^(19|20)?[0-9]{8}?[0-9]{4}$/,
            },
            type: 'reciever',
        });

        $("form[name='machineagreementReciever']").validate({
            rules: {
                ReceiverPersonalNumber: {
                    regexPersonal: true,
                },
                ReceiverEmail: {
                    required: true,
                    email: true,
                },
                ReceiverPhoneNumber: {
                    pattern: /^\+(467)([0-9]{8})$/, // Regex for Swedish Mobile number
                    required: true
                }
            },
            messages: {
                ReceiverPersonalNumber: {
                    regexPersonal: machineAgreementTranslation.personalNumberRegexPersonal,
                },
                ReceiverEmail: {
                    required: machineAgreementTranslation.receiverEmailRequired,
                    email: machineAgreementTranslation.receiverEmailFormat,
                },
                ReceiverPhoneNumber: {
                    required: machineAgreementTranslation.mobileRequired,
                    pattern: machineAgreementTranslation.mobilePattern,
                }
            },
            submitHandler: function () {},
        });
    }

    /**
     * Checking if fields are valid
     * Adding/Removing disabled class if/or not
     * @param {*} steps
     */
    checkForm(steps) {
        switch (steps) {
            case 'form':
                if ($('#machineagreementForm').valid()) {
                    document.getElementById('Step1Next').classList.remove('disabled');
                } else {
                    document.getElementById('Step1Next').classList.add('disabled');
                }
                break;
            case 'reciever':
                if ($('#machineagreementReciever').valid()) {
                    document.getElementById('Step2Next').classList.remove('disabled');
                } else {
                    document.getElementById('Step2Next').classList.add('disabled');
                }
                break;
        }
    }

    /**
     * Validation Methods for jquery validation
     * @param {*} params
     */
    validationMethods = (params) => {
        switch (params.type) {
            case 'form':
                $.validator.methods.regex = function (value, element) {
                    return this.optional(element) || params.agreementNumber.regx.test(value);
                };
                break;
            case 'reciever':
                $.validator.methods.regexPersonal = function (value, element) {
                    return this.optional(element) || params.agreementNumber.regx.test(value);
                };
                break;
            case 'multifiles':
                $.validator.addMethod(
                    'validateFileTtype',
                    (val, elem) => {
                        let files = $('#' + elem.id)[0].files;
                        for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
                            const fname = files[fileIndex].name.toLowerCase();
                            const re = /(\.pdf)$/i;

                            if (!re.exec(fname)) {
                                return false;
                            }
                        }
                        return true;
                    },
                    machineAgreementTranslation.agreementFileValidateFileTtype
                );
                break;
        }
    };
}
